import React from 'react';
import {Alert, Box, Button, CircularProgress, Container, Divider, Typography} from '@mui/material';
import {styled} from '@mui/system';

const FormWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    marginTop: '25px',
    marginBottom: '25px',
});

const FormContainer = styled(Container)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    padding: '2rem',
    borderRadius: '12px',
    width: '100%',
});

function QrResult({ qrCode, loading, error }) {
    // Extrahiere PNG und SVG aus qrCode, das ein Objekt mit den beiden Formaten enthält
    const { png, svg } = qrCode || {};

    return (
        <FormWrapper>
            <FormContainer>
                <Typography variant="h5" component="h2" gutterBottom>
                    Generated QR Code
                </Typography>

                <Typography>
                    Ihr kostenloser QR-Code zur freien Verwendung. Jetzt runterladen.
                </Typography>

                {loading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                        <CircularProgress />
                    </Box>
                )}

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                {qrCode && !loading && (
                    <>
                        {/* Anzeige des PNG-Bildes */}
                        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                            <img
                                src={png ? png.data : ''}
                                alt="Generated QR Code"
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            {/* Download-Button für PNG */}
                            <Button
                                variant="contained"
                                color="primary"
                                href={png ? png.data : '#'}
                                download="qrcode.png"
                                sx={{ mr: 2 }}
                            >
                                Download PNG
                            </Button>

                            {/* Download-Button für SVG */}
                            <Button
                                variant="contained"
                                color="primary"
                                href={svg ? svg.data : '#'}
                                download="qrcode.svg"
                            >
                                Download SVG
                            </Button>
                        </Box>
                    </>
                )}
            </FormContainer>
        </FormWrapper>
    );
}

export default QrResult;
